<template>
  <div class="NavBar__container">
    <div class="NavBar__left">
      <router-link tabindex="1" to="/">
        <img
          src="@/assets/images/geeksalon-logo.png"
          alt="JavaScript"
          style="height: 100%; padding: 0.75rem 1rem; box-sizing: border-box"
        />
      </router-link>
    </div>
    <ul class="NavBar__right NavBar__ul">
      <li class="NavBar__li">
        <router-link tabindex="1" class="NavBar__link" to="/">Home</router-link>
      </li>
      <li class="NavBar__li">
        <router-link tabindex="1" class="NavBar__link" to="/articles"
          >Articles</router-link
        >
      </li>
      <li class="NavBar__li">
        <router-link
          tabindex="1"
          class="NavBar__link"
          to="/admin"
          v-if="$store.getters.user.isMentor"
          >Admin</router-link
        >
      </li>
      <li class="NavBar__li">
        <a
          @click.prevent="signOut"
          class="NavBar__link"
          role="link"
          tabindex="1"
        >
          <i class="fas fa-sign-out-alt" style="color: red"></i>
        </a>
      </li>
    </ul>
  </div>
</template>

<script setup>
import { signOut } from "@/lib/login"
</script>

<style lang="scss" scoped>
.NavBar__container {
  display: flex;
  justify-content: space-between;
  height: 4rem;
  background: var(--white);
  border-bottom: 1px solid var(--background);
}
// .NavBar__left {
// }
.NavBar__right {
  display: flex;
}
.NavBar__ul {
  margin: 0;
}
.NavBar__li {
  position: relative;
  list-style: none;
  &:after {
    position: absolute;
    bottom: -1px;
    left: 0;
    content: "";
    width: 100%;
    height: 2px;
    background: var(--primary);
    transform: scaleX(0);
    transform-origin: left top;
    transition: transform 0.3s;
  }
  &:hover:after {
    transform: scaleX(1);
  }
  &:focus-within {
    background: var(--background);
  }
}
.NavBar__link {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 1rem;
  height: 100%;
  text-decoration: none;
  cursor: pointer;
  color: var(--text-dark);
}
</style>
